import {
  Component,
  Input,
  Output,
  OnInit,
  EventEmitter,
  ChangeDetectionStrategy,
  Inject,
  PLATFORM_ID
} from '@angular/core';
import { Product, Shipping, User, ContentsService, PaymentMethod } from '@vestiaire/api-sdk-angular';
import { SizeGuide } from '@app/shared/model/interfaces/sizeGuide/sizeGuide';
import { MatDialog } from '@angular/material/dialog';
import { LegalWarrantiesModalComponent } from '@app/+product/components/product-description/legal-warranties-modal/legal-warranties-modal.component';
import { LocaleService } from '@app/core/i18n';
import { isPlatformServer } from '@angular/common';

@Component({
  selector: 'vc-product-description',
  templateUrl: './product-description.component.html',
  styleUrls: ['./product-description.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductDescriptionComponent implements OnInit {
  @Input()
  product: Product;
  @Input()
  user: User | null;
  @Input()
  shipping: Shipping;
  @Input()
  sizeGuide: SizeGuide;
  @Input()
  canReportProducts = false;
  @Input()
  directShippingEligible: boolean;
  public lang: string;
  public country: string;
  public isServer = false;
  public paymentMethod: PaymentMethod[];

  @Output()
  openConditionGuideModal = new EventEmitter<boolean>();
  @Output()
  openCommentsModal = new EventEmitter<boolean>();

  constructor(
    private dialogService: MatDialog,
    private localeService: LocaleService,
    private contentsService: ContentsService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isServer = isPlatformServer(this.platformId);
  }

  ngOnInit() {
    this.getPaymentMethods();
  }

  get isFrench(): boolean {
    return this.localeService.getLanguage() === 'fr' && this.localeService.getCountry() === 'FR';
  }

  openLegalWarrantiesModal(): void {
    const config: any = {
      disableClose: false,
      maxWidth: 600
    };
    this.dialogService.open(LegalWarrantiesModalComponent, config);
  }

  get sellerPro(): boolean {
    return (
      this.product && this.product.seller && this.product.seller.badges && this.product.seller.badges.includes('pro')
    );
  }

  conditionGuideModalComponent(): void {
    this.openConditionGuideModal.emit(true);
  }

  openComments(): void {
    this.openCommentsModal.emit(true);
  }

  getPaymentMethods() {
    this.contentsService.getPaymentMethods().subscribe(
      res => {
        if (res.data) {
          this.paymentMethod = res.data;
        }
      },
      err => {
        // Catch error
      }
    );
  }
}
